import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Manual credit adjust for one employee. Returns { type, amount }. The parent
// calls MembershipV2Service.adjustCredit (which validates + writes the ledger).
@Component({
  selector: 'v2-credit-dialog',
  template: `
  <h2 mat-dialog-title>Adjust credit — {{ data.name }}</h2>
  <mat-dialog-content class="v2-dialog">
    <p class="v2-credit-cur">Current balance: <strong>{{ data.credit }}</strong></p>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Direction</mat-label>
      <mat-select [(ngModel)]="type">
        <mat-option value="credit">Add credit (+)</mat-option>
        <mat-option value="debit">Remove credit (−)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Amount</mat-label>
      <input matInput type="number" [(ngModel)]="amount" min="0">
    </mat-form-field>
    <p class="v2-credit-preview" *ngIf="amount > 0">
      New balance: <strong>{{ preview() }}</strong>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="ref.close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!(amount > 0)" (click)="apply()">Apply</button>
  </mat-dialog-actions>
  `,
  styles: [`
    .v2-credit-cur, .v2-credit-preview { font-size: 13px; margin: 4px 0 12px; }
    .full { width: 100%; }
  `]
})
export class CreditDialogComponent {
  type: 'credit' | 'debit' = 'credit';
  amount = 0;
  constructor(
    public ref: MatDialogRef<CreditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  preview() {
    const base = Number(this.data.credit) || 0;
    const amt = Number(this.amount) || 0;
    return this.type === 'credit' ? base + amt : base - amt;
  }
  apply() {
    if (!(this.amount > 0)) { return; }
    this.ref.close({ type: this.type, amount: Number(this.amount) });
  }
}
